export default __webpack_public_path__ + "static/media/centos.76209bae.png";